import {
  adminsSearchSchema,
  adminsViewColumns,
  mapAdminsViewQuery,
} from "./AdminsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getPlatformAdmins } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface AdminsViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  readonly onAction?: (key: string, record: any) => void;
}

function AdminsView(props: AdminsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={adminsViewColumns}
      schema={adminsSearchSchema}
      mapQuery={mapAdminsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getPlatformAdmins, { retry: true })}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("PlatformUsers", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("PlatformUsers", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default AdminsView;
